import {Constants} from '@client/util/constants';
import fromS3 from '@client/util/s3';

const DEFAULT_GOAL_IMAGE = `${Constants.LOCAL_IMAGE_BASE}default-goal.svg`;

export default class CurrentGoal {
  constructor() {
    this.isLoaded = false;
    this.accounts = null;
    this.totalCash = null;
    this.totalValue = null;
    this.name = null;
    this.retirementAge = null;
    this.displayType = null;
    this.targetDate = null;
    this.img = null;
    this.currentAge = null;
    this.currentPortfolio = null;
    this.targetPortfolio = null;
    this.wealthProjection = null;
    this.id = null;
    this.goalLengthMonths = null;
    this.segmentGoalId = null;
    this.portfolioDesc = null;
    this.portfolioType = null;
    this.thumbnail = null;
    this.created = null;
    this.portfolioLastUpdated = null;
  }

  loadData(payload) {
    if (!payload) {
      return;
    }

    this.id = payload[0][0].goal_id;
    this.totalCash = payload[0][0].cash;
    this.totalValue = payload[0][0].value;
    this.name = payload[0][0].name;
    this.retirementAge = payload[0][0].retirementAge;
    this.goalLengthMonths = payload[0][0].goalLengthMonths;
    this.displayType = payload[0][0].displayType;
    this.segmentGoalId = payload[0][0].segmentGoalId;

    if (typeof this.displayType === 'string') {
      // make sure its always an int
      // eslint-disable-next-line radix
      this.displayType = Number.parseInt(this.displayType);
    }

    this.targetDate = payload[0][0].target_date;

    // eslint-disable-next-line no-negated-condition, unicorn/no-negated-condition
    this.img = payload[0][0].thumbnail_link !== null ? fromS3(payload[0][0].thumbnail_link) : DEFAULT_GOAL_IMAGE;
    // eslint-disable-next-line no-negated-condition, unicorn/no-negated-condition
    this.thumbnail = payload[0][0].thumbnail_link !== null ? payload[0][0].thumbnail_link : DEFAULT_GOAL_IMAGE;

    this.currentAge = payload[0][0].user_current_age;

    // eslint-disable-next-line prefer-destructuring
    this.accounts = payload[1];

    this.portfolioDesc = payload[0][0].portfolioDesc;
    this.portfolioType = payload[0][0].portfolioType;

    this.isLoaded = true;
    this.created = payload[0][0].created;
    this.portfolioLastUpdated = payload[0][0].portfolioLastUpdated ?? payload[0][0].created;
  }
}
